export default __webpack_public_path__ + "static/fakegoogle_1-e05e21c236b7f5c324063724b5af66da.jpg";